module.exports = __webpack_public_path__ + "img/3.62c0bbbf.svg";